"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsTagBuilder = void 0;
const string_format_1 = require("@ampcore/string-format");
class AnalyticsTagBuilder {
    constructor() {
        this.DATA_ANALYTICS_ATTRIBUTE = 'data-analytics';
        this.DATA_TARGET_ANALYTICS_ATTRIBUTE = 'data-target-analytics';
        this.DATA_PSN_ANALYTICS_ATTRIBUTE = 'data-psn-analytics';
        this.DATA_AB_TEST_ANALYTICS_ATTRIBUTE = 'data-abtest-analytics';
        this._delimiter = '-';
        this.dataAnalyticAttributeValue = (value, fallbackValue) => {
            if (value === undefined && fallbackValue === undefined) {
                return (0, string_format_1.kebabCase)(this.getScope(false));
            }
            else if (value === undefined && fallbackValue !== undefined) {
                return (0, string_format_1.kebabCase)(`${this.getScope(true)}${fallbackValue}`);
            }
            return (0, string_format_1.kebabCase)(`${this.getScope(true)}${value}`);
        };
        this.dataAnalyticAttribute = (value, fallbackValue) => {
            const attributes = {};
            if (value || fallbackValue || this._analyticsName || this._defaultName) {
                attributes[this.DATA_ANALYTICS_ATTRIBUTE] =
                    this.dataAnalyticAttributeValue(value, fallbackValue);
            }
            if (this._psnAnalyticsName) {
                attributes[this.DATA_PSN_ANALYTICS_ATTRIBUTE] = this._psnAnalyticsName;
            }
            if (this._abTestAnalyticsName) {
                attributes[this.DATA_AB_TEST_ANALYTICS_ATTRIBUTE] =
                    this._abTestAnalyticsName;
            }
            return attributes;
        };
        this.dataTargetAnalyticAttributeValue = (value) => {
            if (value) {
                const dataAnalyticAttribute = this.dataAnalyticAttributeValue(value);
                return `${dataAnalyticAttribute}${this._delimiter}placeholder`;
            }
            return (0, string_format_1.kebabCase)(`${this.getScope(true)}placeholder`);
        };
        this.dataTargetAnalyticAttribute = (defaultName, analyticName) => {
            return {
                [this.DATA_TARGET_ANALYTICS_ATTRIBUTE]: this.dataTargetAnalyticAttributeValue(defaultName || analyticName)
            };
        };
    }
    setDefaultName(value) {
        const trimmedValue = value?.trim();
        if (!trimmedValue) {
            this._defaultName = undefined;
            return this;
        }
        this._defaultName = trimmedValue;
        return this;
    }
    setAnalyticsName(value) {
        const trimmedValue = value?.trim();
        if (!trimmedValue) {
            this._analyticsName = undefined;
            return this;
        }
        this._analyticsName = trimmedValue;
        return this;
    }
    setDelimiter(value) {
        this._delimiter = value.trim();
        return this;
    }
    getDelimiter() {
        return this._delimiter;
    }
    getScope(delimiter) {
        const scope = this._analyticsName ?? this._defaultName ?? '';
        if (delimiter && scope !== '') {
            return `${scope}${this._delimiter}`;
        }
        return scope;
    }
    // Include PSN value if it is set, which is the same for all children
    // of the same component without suffix
    setPsnAnalytics(value) {
        if (value?.trim()) {
            this._psnAnalyticsName = value.trim();
        }
        else {
            this._psnAnalyticsName = undefined;
        }
        return this;
    }
    // Include AB testing analytics value if it is set
    setAbTestAnalytics(value) {
        if (value?.trim()) {
            this._abTestAnalyticsName = value.trim();
        }
        else {
            this._abTestAnalyticsName = undefined;
        }
        return this;
    }
}
exports.AnalyticsTagBuilder = AnalyticsTagBuilder;
